import { logger } from '@springtree/eva-sdk-core-logger';
import { dequal } from 'dequal';
import { useState } from 'react';
import { useRecoilValueLoadable } from 'recoil';
/**
 * This hook provides synchronous access to a service error response.
 * The error will be unset as soon as the service returns to its loadable state.
 *
 * @template SVC
 * @param {({
 *     serviceState: IServiceState<SVC>|IAnonymousServiceState<SVC>,
 *     defaultValue?: SVC['response'],
 *   })} {
 *     serviceState,
 *     defaultValue,
 *   }
 * @returns
 */
export const useGetServiceError = (serviceState) => {
    const [currentError, setError] = useState();
    const responseLoadable = useRecoilValueLoadable(serviceState.error);
    let newError;
    switch (responseLoadable.state) {
        case 'hasValue':
            newError = responseLoadable.contents;
            break;
        case 'loading':
            newError = undefined;
            break;
        case 'hasError':
            newError = responseLoadable.contents;
            break;
    }
    if (!dequal(currentError, newError)) {
        setError(newError);
        logger.warn('New error', newError)();
    }
    return currentError;
};
export default useGetServiceError;
//# sourceMappingURL=use-get-service-error.js.map